import { ISelect } from '../../../../shared/types/shared';

export const formatOrbitSelect = <T extends ISelect>(list: T[]): ISelect[] =>
    JSON.parse(JSON.stringify(list))?.map((item: T) => ({
        id: item.id,
        name: item.name,
        ...(item.code != null && String(item.code).trim() !== ''
            ? { code: String(item.code) }
            : {}),
    }));

export const getOptionLabel = (options: ISelect[], value?: string): string => {
    if (!value?.trim()) return '';

    const match = options.find(
        (option) =>
            String(option.id) === String(value) ||
            String(option.code ?? '') === String(value)
    );

    return match?.name ? String(match.name) : value;
};

export const getOptionName = (
    options: ISelect[],
    value?: string
): string | undefined => {
    if (!value?.trim()) return undefined;

    const match = options.find(
        (option) =>
            String(option.id) === String(value) ||
            String(option.code ?? '') === String(value)
    );

    return match?.name ? String(match.name) : undefined;
};
